import { STOCK_ADJUSTMENT_REASONS } from '../constants/Stock';
import { IN_STORE_PAYMENT_METHODS } from '../constants/StorePaymentMethod';

const exceeds = (value, maximum) => Number(value) > Number(maximum) + 1e-9;

export const validateStockAdjustment = ({
  productId,
  reason,
  packageQuantity,
  countedPackageQuantity,
  onHandPackages,
  amountReturned,
  refundPaymentMethod,
}) => {
  const errors = {};

  if (!productId) {
    errors.productId = 'stock.validation.productRequired';
  }

  if (!STOCK_ADJUSTMENT_REASONS.includes(reason)) {
    errors.reason = 'stock.validation.reasonRequired';
  }

  const onHand = Number(onHandPackages);
  const hasOnHand = Number.isFinite(onHand);

  if (reason === 'CountCorrection') {
    const counted = Number(countedPackageQuantity);
    if (!Number.isFinite(counted) || counted < 0) {
      errors.countedPackageQuantity = 'stock.validation.countInvalid';
    } else if (hasOnHand && exceeds(counted, onHand)) {
      errors.countedPackageQuantity = 'stock.validation.countExceedsOnHand';
    } else if (hasOnHand && Math.abs(counted - onHand) < 1e-9) {
      errors.countedPackageQuantity = 'stock.validation.countUnchanged';
    }
  } else if (reason) {
    const removed = Number(packageQuantity);
    if (!Number.isFinite(removed) || removed <= 0) {
      errors.packageQuantity = 'stock.validation.quantityRemovedRequired';
    } else if (hasOnHand && exceeds(removed, onHand)) {
      errors.packageQuantity = 'stock.validation.quantityExceedsOnHand';
    }
  }

  if (reason === 'ReturnedToSupplier') {
    const amount = Number(amountReturned);
    if (amountReturned === '' || amountReturned == null || !Number.isFinite(amount) || amount < 0) {
      errors.amountReturned = 'stock.validation.amountReturnedInvalid';
    } else if (amount > 0 && !IN_STORE_PAYMENT_METHODS.includes(refundPaymentMethod)) {
      errors.refundPaymentMethod = 'stock.validation.paymentMethodRequired';
    }
  }

  return errors;
};

export const buildStockAdjustmentPayload = (form) => {
  const notes = String(form?.notes || '').trim();
  const payload = {
    productId: form.productId,
    reason: form.reason,
    notes: notes || null,
  };

  if (form.reason === 'CountCorrection') {
    payload.countedPackageQuantity = Number(form.countedPackageQuantity);
    return payload;
  }

  payload.packageQuantity = Number(form.packageQuantity);
  if (form.reason === 'ReturnedToSupplier') {
    payload.amountReturned = Number(form.amountReturned);
    if (payload.amountReturned > 0) {
      payload.refundPaymentMethod = form.refundPaymentMethod;
    }
  }
  return payload;
};
